package main.kotlin.data

fun Collection<Any>.atBottom(index:Int) : Boolean
{
    return index >= count()-1
}
